// extracted by mini-css-extract-plugin
export default {"main":"Links_main__fF5bI","link":"Links_link__GDvcX"};